// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5e221a9","553":"b4f56a47","977":"dc5e6b87"}[chunkId] + ".chunk.js";
};